exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-label{margin-top:20px;margin-bottom:20px}\n", ""]);

// exports
